import {ContentChild, Directive, forwardRef, TemplateRef, Input} from "@angular/core";

let nextId: number = 0;


export class Tab {

     name: string = "tab-" + nextId++;
     disabled: boolean = false;

     private header: TabHeader;
     private body: TabBody;
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: "a2-tab"
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'name': [{ type: Input },],
'disabled': [{ type: Input },],
'header': [{ type: ContentChild, args: [forwardRef(() => TabHeader), ] },],
'body': [{ type: ContentChild, args: [forwardRef(() => TabBody), ] },],
};
}


export class TabHeader {
    constructor(public templateRef: TemplateRef<any>) {
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: "template[tabHeader]"
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
{type: TemplateRef, },
];
}


export class TabBody {
    constructor(public templateRef: TemplateRef<any>) {
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: "template[tabBody]"
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
{type: TemplateRef, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
